/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react'
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import { NavbarTopAdmin, NavbarBottomAdmin } from '../admin/components'
import { useDispatch } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { sostituisci } from '../../redux/creaEvento'
import axios from 'axios'
import DivBottom from '../userNotAuth/components/divBottom'
import EsempiSottotitoli from './components/esempiSottotitoli'

let filter = []// array per visualizzare le città in base all'input del client
let filter2 = []// array per visualizzare le regione in base all'input del client

function EditEvento1() {
    const dispatch = useDispatch()
    const navigate = useNavigate(); const location = useLocation()
    const idEvento = location.state?.idEvento; const today = new Date().toISOString().slice(0, 10)

    const [formData, setFormData] = useState({})
    const [cityFilter, setCityFilter] = useState(null)//città filtrate ad ogni change dell'input 'città'
    const [regioneFilter, setRegioneFilter] = useState(null)//regione filtrate ad ogni change dell'input 'regione'
    const [msg, setMsg] = useState({ msgTitolo: null, msgProvincia: null, msgComune: null, msgIndirizzo: null, msgCittà: null, msgRegione: null })
    const [validateTipologia, setValidateTipologia] = useState(null)

    const città = ['Agrigento', 'Alessandria', 'Ancona', 'Aosta', 'Aquila', 'Arezzo', 'Ascoli Piceno', 'Asti', 'Avellino',
        'Bari', 'Barletta-Andria-Trani', 'Belluno', 'Benevento', 'Bergamo', 'Biella', 'Bologna', 'Bolzano', 'Brescia', 'Brindisi',
        'Cagliari', 'Caltanissetta', 'Campobasso', 'Carbonia-Iglesias', 'Caserta', 'Catania', 'Catanzaro', 'Chieti', 'Como', 'Cosenza', 'Cremona', 'Crotone', 'Cuneo',
        'Enna',
        'Fermo', 'Ferrara', 'Firenze', 'Foggia', 'Forlì e Cesena', 'Frosinone',
        'Genova', 'Gorizia', 'Grosseto',
        'Imperia', 'Isernia',
        'La Spezia', 'Latina', 'Lecce', 'Lecco', 'Livorno', 'Lodi', 'Lucca',
        'Macerata', 'Mantova', 'Massa-Carrara', 'Matera', 'Messina', 'Milano', 'Modena', 'Monza della Brianza',
        'Napoli', 'Novara', 'Nuoro',
        'Oristano',
        'Padova', 'Palermo', 'Parma', 'Pavia', 'Perugia', 'Pesaro e Urbino', 'Pescara', 'Piacenza', 'Pisa', 'Pistoia', 'Pordenone', 'Potenza', 'Prato',
        'Ragusa', 'Ravenna', 'Reggio Calabria', 'Reggio Emilia', 'Rieti', 'Rimini', 'Roma', 'Rovigo',
        'Salerno', 'Sassari', 'Savona', 'Siena', 'Siracusa', 'Sondrio',
        'Taranto', 'Teramo', 'Terni', 'Torino', 'Trapani', 'Trento', 'Treviso', 'Trieste',
        'Udine',
        'Varese', 'Venezia', 'Verbano-Cusio-Ossola', 'Vercelli', 'Verona', 'Vibo Valentia', 'Vicenza', 'Viterbo']
    const regione = ['Abruzzo', 'Basilicata', 'Calabria', 'Campania', 'Emilia Romagna', 'Friuli Venezia Giulia', 'Lazio', 'Liguria', 'Lombardia',
        'Marche', 'Molise', 'Piemonte', 'Puglia', 'Sardegna', 'Sicilia', 'Toscana', 'Trentino Alto Adige', 'Umbria', "Val d'Aosta", 'Veneto'
    ]
    const cittàValue = useRef()//per modificare il value nell'input 'città'
    const regioneValue = useRef()//per modificare il value nell'input 'regione'
    const cityFilterId = useRef()//per display 'block' o 'none' del div delle città selezionabili
    const regioneFilterId = useRef()//per display 'block' o 'none' del div delle regioni selezionabili
    const dataFineId = useRef()
    const dataInizioId = useRef()
    const provincia = useRef()
    const bodyId = useRef(); const tipologia = useRef()
    const childRef = useRef(null) // puntamento al dom nel componente 'ESEMPI SOTTOTITOLI'

    async function evento() {
        const res = await axios.get(`/getEventoById/${idEvento}/${localStorage.getItem('email')}`)
        res.data = { ...res.data }
        setFormData(res.data)
    }
    function handleChange(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        let inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value

        if (!(/^([a-zA-Z]{0,})$/.test(inputValue))) {
            const content = document.getElementById(name)
            if (name === 'provincia') { content.value = ''; setMsg({ msgProvincia: 'Carattere non consentito' }); return }
        } else setMsg({ msgProvincia: null })

        if (name === 'dataInizio') {
            dataInizioId.current.value = new Date(inputValue).toISOString().slice(0, 10)
            let ingresso = new Date(inputValue).toISOString().slice(0, 10)
            dataFineId.current.min = ingresso//setta il range minimo nel calendario in input dataFine
            if (dataInizioId.current.value > dataFineId.current.value) {
                dataFineId.current.value = ingresso;
                setFormData({ ...formData, dataFine: inputValue, dataInizio: inputValue }); return
            }
        }

        if (name === 'pubblicitàFB') {//setta checkbox pubblicitàFB
            switch (inputValue) {
                case true: setFormData({ ...formData, pubblicitàFB: 1 }); return
                case false: setFormData({ ...formData, pubblicitàFB: 0 }); return
                default:
            }
        }
        setFormData({ ...formData, [name]: inputValue })//valorizzo il name del nuovo oggetto formData

        if (name === 'provincia') {
            provincia.current.value = inputValue.toUpperCase()
        }
        setValidateTipologia(null)
        tipologia.current.style.border = '1px solid black'
    }
    function handleChangeCittà(e) {
        const { value } = e.target
        filter = []; setCityFilter(null)
        città.forEach((elem, index) => {//filtraggio città da input 'città'
            if (value.toLowerCase() !== '') {
                let result = elem.substring(0, value.length)//result è l'elemento di array 'città' con i numeri di caratteri iniziali uguali all'input 'città'
                if (result.toLowerCase() === value.toLowerCase()) {//match tra input 'città' e array città
                    filter.push(elem)//carico l'array con le città trovate        
                }
            }
        })
        if (filter.length > 0) {//se in input 'città' viene trovata una città in array 'citta'
            setCityFilter(filter)
            setMsg({ msgCittà: null })
            cityFilterId.current.style.display = 'block'
        } else {
            cityFilterId.current.style.display = "none"
            setMsg({ msgCittà: 'Città non trovata' })
        }
    }
    function handleChangeRegione(e) {
        const { value } = e.target
        filter2 = []; setCityFilter(null)
        regione.forEach((elem, index) => {//filtraggio regione da input 'regione'
            if (value.toLowerCase() !== '') {
                let result = elem.substring(0, value.length)//result è l'elemento di array 'regione' con i numeri di caratteri iniziali uguali all'input 'regione'
                if (result.toLowerCase() === value.toLowerCase()) {//match tra input 'regione' e array regione
                    filter2.push(elem)//carico l'array con le regione trovate        
                }
            }
        })
        if (filter2.length > 0) {//se in input 'regione' viene trovata una regione in array 'citta'
            setRegioneFilter(filter2)
            setMsg({ msgRegione: null })
            regioneFilterId.current.style.display = 'block'
        } else {
            regioneFilterId.current.style.display = "none"
            setMsg({ msgRegione: 'Regione non trovata' })
        }
    }
    function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        if (formData.città === null || msg.msgCittà === "Città non trovata" || cittàValue.current.value === '') {
            setMsg({ msgCittà: 'Campo obbligatorio' }); window.scrollTo(0, 100); return
        }
        if (formData.regione === null || msg.msgRegione === "Regione non trovata" || regioneValue.current.value === '') {
            setMsg({ msgRegione: 'Campo obbligatorio' }); window.scrollTo(0, 100); return
        }
        if (!formData.tipologia) {
            setValidateTipologia('Campo obbligatorio')
            tipologia.current.style.border = '1px solid red'; window.scrollTo(0, 0); return
        }
        dispatch(sostituisci(formData))
        navigate('/editEvento2', {
            replace: true,
            state: { idEvento: idEvento }//per gestire le foto se provengo da 'addEvento2'
        })
    }
    const cittàCliccata = (elem) => {//porta in input 'cittàValue' la città che clicchiamo dalla lista delle città
        cittàValue.current.value = elem
        setFormData({ ...formData, città: elem })
        setCityFilter(null)
    }
    const regioneCliccata = (elem) => {//porta in input 'cittàValue' la città che clicchiamo dalla lista delle città
        regioneValue.current.value = elem
        setFormData({ ...formData, regione: elem })
        setRegioneFilter(null)
    }
    function sottotitoli() {
        if (childRef.current) {
            if (childRef.current.className === 'divNotifiche') {
                document.body.style.overflow = "hidden"
                childRef.current.className = "divNotificheAperto"
            }
            else {
                childRef.current.className = 'divNotifiche'
                document.body.style.overflow = "scroll"
            }
        }
    }
    function esempioCliccato(data) {
        setFormData({ ...formData, sottotitolo: data })
        childRef.current.className = 'divNotifiche'
        document.body.style.overflow = "scroll"
    }
    useEffect(() => {//bodyId è il document.body
        cittàValue.current.addEventListener('change', () => {
            bodyId.current.addEventListener('mouseup', onMouseUp)
            function onMouseUp() {//gestione input 'cittàValue' al click nel body del documento    
                if (formData.città || cityFilterId.current.style.display === "block") {
                    cittàValue.current.value = formData.città
                    cityFilterId.current.style.display = "none"
                    setMsg({ msgCittà: null })
                    bodyId.current.removeEventListener('mouseup', onMouseUp)
                }
            }
        })
        regioneValue.current.addEventListener('change', () => {
            bodyId.current.addEventListener('mouseup', onMouseUp)
            function onMouseUp() {//gestione input 'regioneValue' al click nel body del documento    
                if (formData.regione || regioneFilterId.current.style.display === "block") {
                    regioneValue.current.value = formData.regione
                    regioneFilterId.current.style.display = "none"
                    setMsg({ msgRegione: null })
                    bodyId.current.removeEventListener('mouseup', onMouseUp)
                }
            }
        })
        if (idEvento || !localStorage.getItem('idUser')) { evento() } else navigate('/')
        window.scrollTo(0, 0)
    }, [idEvento])

    useEffect(() => {
        if (formData.prezzo === '0') setFormData({ ...formData, biglietto: false, noBiglietto: true, sito: false })
        if (formData.prezzo !== '0' && formData.prezzo !== 'vai al sito web')
            setFormData({ ...formData, biglietto: true, noBiglietto: false, sito: false })
        if (formData.prezzo === 'vai al sito web')
            setFormData({ ...formData, biglietto: false, noBiglietto: false, sito: true })
    }, [formData.prezzo])

    // useEffect(() => { console.log(formData.tipolgia) }, [formData])
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <div ref={bodyId} style={{ marginTop: '6rem' }}>
            <h2 className='m-5'>Modifica evento (1)</h2>
            <div className='container' style={{ marginBottom: '0rem' }}>

                <form onSubmit={handleSubmit}>
                    <div className="col-md-6">
                        {/* titolo */}
                        <label htmlFor='titolo'>Titolo dell'evento *</label>
                        <input className="form-control fw-bold" id="titolo"
                            name="titolo"
                            defaultValue={formData.titolo}
                            onChange={handleChange}
                            required
                            maxLength={50}
                            type="text" />
                        {msg.msgTitolo && <p style={{ color: 'red', fontSize: 'small' }}><i>{msg.msgTitolo}</i></p>}

                        {/* sottotitolo */}
                        <div className='mt-4'>
                            <label htmlFor='sottotitolo'>Sottotitolo dell'evento</label>
                            <p><i style={{ fontSize: '14px', color: 'maroon' }}>
                                descrivi cosa vivrà il partecipante o un motivo per cui l'evento è importante  <button type='button' onClick={sottotitoli} style={{
                                    backgroundColor: 'maroon', color: 'white', border: 'none', borderRadius: '5px'
                                }}>esempi</button>
                            </i></p>
                            <textarea className="form-control" id="sottotitolo"
                                name="sottotitolo"
                                rows={5}
                                maxLength={250}
                                defaultValue={formData.sottotitolo}
                                onChange={handleChange}
                                type="text"
                            />
                        </div>

                        {/* tipologia */}
                        <div className="mt-4">
                            <label htmlFor='tipologia'>Tipologia evento *</label>
                            <select className="form-select mt-3 fw-bold" aria-label="Default select example" style={{ width: 'auto' }}
                                name="tipologia" ref={tipologia}
                                value={formData.tipologia ?? ""}
                                onChange={handleChange} >
                                <option value=''></option>
                                <option value="Auto raduno">Auto raduno</option>
                                <option value="Benessere olistico">Benessere olistico</option>
                                <option value="Carnevale">Carnevale</option>
                                <option value="Concerto">Concerto</option>
                                <option value="Concorso">Concorso</option>
                                <option value="Cultura">Cultura</option>
                                <option value="Enogastronomico">Enogastronomico</option>
                                <option value="Evento ludico">Evento ludico</option>
                                <option value="Fashion">Fashion</option>
                                <option value="Festa del patrono">Festa del patrono</option>
                                <option value="Festa a tema">Festa a tema</option>
                                <option value="Festival">Festival</option>
                                <option value="Fiera">Fiera</option>
                                <option value="Halloween">Halloween</option>
                                <option value="Luna park">Luna park</option>
                                <option value="Meeting">Meeting</option>
                                <option value="Mercatino">Mercatino</option>
                                <option value="Mercatino natalizio">Mercatino natalizio</option>
                                <option value="Moto raduno">Moto raduno</option>
                                <option value="Mostra">Mostra</option>
                                <option value="Mostra-mercato-fiori">Mostra-mercato-fiori</option>
                                <option value="Natale">Natale</option>
                                <option value="Notte bianca">Notte bianca</option>
                                <option value="Presepe">Presepe</option>
                                <option value="Sagra">Sagra</option>
                                <option value="Spettacolo di magia">Spettacolo di magia</option>
                                <option value="Spettacolo teatrale">Spettacolo teatrale</option>
                                <option value="Sportivo">Sportivo</option>
                                <option value="Altro">Altro</option>
                            </select>
                            {validateTipologia && <p style={{ color: 'red' }}><i>{validateTipologia}</i></p>}
                        </div>

                        {/* regione */}
                        <div className="mt-4">
                            <label htmlFor='città'>Regione *</label>
                            <input
                                defaultValue={formData.regione}
                                ref={regioneValue}
                                className='form-control fw-bold'
                                name='regione'
                                type='text'
                                onChange={handleChangeRegione} />
                        </div>

                        <div ref={regioneFilterId} style={{
                            border: '1px solid black', padding: '5px', margin: '5px', overflow: 'auto', position: 'absolute', width: '20rem',
                            display: 'none', backgroundColor: 'whitesmoke'
                        }}>
                            {regioneFilter &&
                                regioneFilter.map((elem, index) => (
                                    <div className='filterCity' key={index}>
                                        <p style={{ fontFamily: 'sans-serif', cursor: 'pointer' }} onClick={() => { regioneCliccata(elem) }}>{elem}
                                        </p>
                                    </div>
                                ))}
                        </div>
                        {msg.msgRegione && <p style={{ color: 'red' }}>{msg.msgRegione}</p>}



                        {/* città */}
                        <div className="mt-4">
                            <label htmlFor='città'>Città (provincia) *</label>
                            <input
                                defaultValue={formData.città}
                                ref={cittàValue}
                                className='form-control fw-bold'
                                name='città'
                                type='text'
                                onChange={handleChangeCittà} />
                        </div>

                        <div ref={cityFilterId} style={{
                            border: '1px solid black',
                            padding: '5px',
                            margin: '5px',
                            overflow: 'auto',
                            position: 'absolute',
                            width: '20rem',
                            display: 'none',
                            backgroundColor: 'whitesmoke'
                        }}>
                            {cityFilter &&
                                cityFilter.map((elem, index) => (
                                    <span className='filterCity' key={index}>
                                        <p style={{ fontFamily: 'sans-serif', cursor: 'pointer' }} onClick={() => { cittàCliccata(elem) }}>{elem}
                                        </p>
                                    </span>
                                ))}
                        </div>
                        {msg.msgCittà && <p style={{ color: 'red' }}>{msg.msgCittà}</p>}

                        {/*Comune*/}
                        <label htmlFor='comune'>Località *</label>
                        <input className="form-control fw-bold"
                            defaultValue={formData.comune} id="comune"
                            name='comune'
                            onChange={handleChange}
                            required
                            maxLength={30}
                            type='text' />
                        {msg.msgComune && <p style={{ color: 'red', fontSize: 'small' }}><i>{msg.msgComune}</i></p>}

                        {/*Indirizzo*/}
                        <label htmlFor='indirizzo'>Indirizzo/Indicazioni *</label>
                        <input className="form-control fw-bold"
                            defaultValue={formData.indirizzo} id="indirizzo"
                            name='indirizzo' required
                            onChange={handleChange}
                            placeholder='Es. piazza Cavour'
                            maxLength={30}
                            type='text' />
                        {msg.msgIndirizzo && <p style={{ color: 'red', fontSize: 'small' }}><i>{msg.msgIndirizzo}</i></p>}

                        {/*Provincia*/}
                        <div className='mt-4'> <label htmlFor='form-control fw-bold'>Sigla provincia</label></div>
                        <input className="form-control" id="provincia" ref={provincia}
                            defaultValue={formData.provincia}
                            name='provincia'
                            onChange={handleChange}
                            required
                            maxLength={3}
                            placeholder='Es: RM'
                            type='text' />
                        {msg.msgProvincia && <p style={{ color: 'red', fontSize: 'small' }}><i>{msg.msgProvincia}</i></p>}

                        <div className='mt-4' style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', padding: '10px' }} >
                            {/*data inizio */}
                            <div> <label htmlFor='dataInizio'>Data inizio</label> </div>
                            <div> <input
                                ref={dataInizioId}
                                defaultValue={formData.dataInizio}
                                // min={today}
                                name="dataInizio"
                                onChange={handleChange}
                                required
                                type="date" />
                            </div>

                            {/*ora inizio */}
                            <div> <label htmlFor='oraInizio'>Ora inizio</label></div>
                            <div> <input
                                defaultValue={formData.oraInizio}
                                type='time'
                                name='oraInizio'
                                onChange={handleChange} />
                            </div>

                            {/*data fine */}
                            <div> <label htmlFor='dataFine'>Data fine</label> </div>
                            <div> <input
                                ref={dataFineId}
                                defaultValue={formData.dataFine}
                                min={today}
                                name="dataFine"
                                onChange={handleChange}
                                required
                                type="date" />
                            </div>

                            {/*ora Fine */}
                            <div> <label htmlFor='oraFine'>Ora fine</label></div>
                            <div> <input
                                defaultValue={formData.oraFine}
                                type='time'
                                name='oraFine'
                                onChange={handleChange} />
                            </div>
                        </div>

                        {/* Pubblicità in FB */}
                        <div className='mt-3' style={{ display: 'grid', gridTemplateColumns: '2rem 1fr', gap: '4px' }} >
                            <div><input type='checkbox'
                                name='pubblicitàFB'
                                checked={true}
                                onChange={handleChange} />
                            </div>
                            <div><label>Condivisione evento su FaceBook</label></div>

                            <div></div>
                            <div style={{ fontSize: 'small' }}><i>il tuo evento sarà condiviso su FB alla pagina ZonaEventi gratuitamente e potrà avere più visite</i></div>
                        </div><hr />

                        {/*fine display grid per date e ore inizio...fine*/}
                        <p className='mt-2'><i>* campi obbligatori</i></p>
                        <div className='mt-3'>
                            <button type='button' className='btn btn-secondary' onClick={() => {
                                navigate(-1)
                            }}>Annulla
                            </button>
                            <button type='submit' className='btn btn-primary' style={{ marginLeft: '2rem' }}>Avanti</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <EsempiSottotitoli refFiglio={childRef} props={esempioCliccato} />
        <DivBottom />
    </>)
}
export default EditEvento1